import { devHandlers } from "devMocks/handlers";
import { setupWorker } from "msw/browser";
import { envConfig } from "utils/envConfig";

export async function startDevMockWorker(): Promise<void> {
  const baseUrl = envConfig.ApiUrl.endsWith("/") ? envConfig.ApiUrl : `${envConfig.ApiUrl}/`;
  const worker = setupWorker(...devHandlers(baseUrl));
  await worker.start({
    onUnhandledRequest: "bypass",
  });
}
